import { TPeriodDays } from '@src/app/shared/types/common';

export const injectCalcPeriodDays = ({
  rates,
}: {
  rates: Record<string, string | number>[];
}): TPeriodDays =>
  ({
    min: rates[0]['perioddaysmin'] as number,
    max: rates[rates.length - 1]['perioddaysmax'] as number,
  }) as const;
